import { Field, Input, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  input: {
    width: '100%',
    minHeight: '2.5rem',
  },
  inputContent: {
    '& input': {
      paddingBlock: tokens.spacingVerticalS,
    },
  },
  contentBefore: {
    color: tokens.colorNeutralForeground3,
    display: 'inline-flex',
    '& svg': {
      width: '1.5rem',
      height: '1.5rem',
    },
  },
  suffix: {
    color: tokens.colorNeutralForeground3,
    paddingRight: tokens.spacingHorizontalS,
  },
});

export type IconFieldProps = {
  icon?: ReactNode;
  label: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  type?: 'text' | 'number';
  min?: number;
  onChange?: (value: string) => void;
  suffix?: string;
  errorMessage?: string;
};

export function IconField({
  icon,
  label,
  value,
  readOnly = false,
  disabled = false,
  type = 'text',
  min,
  onChange,
  suffix,
  errorMessage,
}: IconFieldProps) {
  const styles = useStyles();
  return (
    <Field label={label} validationMessage={errorMessage}>
      <Input
        className={mergeClasses(styles.input, styles.inputContent)}
        appearance={disabled ? 'filled-lighter' : 'outline'}
        type={type}
        min={min}
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        contentBefore={icon ? <span className={styles.contentBefore}>{icon}</span> : undefined}
        contentAfter={suffix ? <span className={styles.suffix}>{suffix}</span> : undefined}
        onChange={(event) => onChange?.(event.target.value)}
      />
    </Field>
  );
}
